module.exports = __webpack_public_path__ + "img/NO937886160.51bf6da4.png";